import ColorModeSetting from './ColorModeSetting';

export default ColorModeSetting;
